import { render } from "./pageModulesEditor.vue?vue&type=template&id=45a718c1&scoped=true"
import script from "./pageModulesEditor.vue?vue&type=script&lang=js"
export * from "./pageModulesEditor.vue?vue&type=script&lang=js"

import "./pageModulesEditor.vue?vue&type=style&index=0&id=45a718c1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a718c1"]])

export default __exports__